import { Button, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import Steper from "components/common/Steper";
import { useStyles } from "components/request-document/components/Commons";
import { REQUEST_DOCUMENT_STEP } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import React from "react";
import { useDispatch } from "react-redux";
import { setSmartFormStep } from "redux/modules/uiSlice";

export default function SmartFormStepper({ currentStep = 0 }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleClickStep = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        dispatch(setSmartFormStep(SMART_T_STEP.NONE));
        break;
      case 1:
        dispatch(setSmartFormStep(SMART_T_STEP.PART_A_1));
        break;
      case 2:
        dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        break;
      default:
        break;
    }
  };

  const shouldRenderPagination = currentStep > 0;

  return (
    <>
      <Steper
        currentStep={currentStep}
        stepInfo={REQUEST_DOCUMENT_STEP}
        // onClickStep={handleClickStep}
      />
      {shouldRenderPagination && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 62,
          }}
        >
          <Button style={{ textTransform: "capitalize" }}>
            <Typography style={{ textDecoration: "none" }} color="primary">
              Back &nbsp;
            </Typography>
          </Button>
          <div className={classes.flexRow}>
            <Typography color="primary">Page &nbsp;</Typography>
            <Pagination
              page={currentStep}
              count={3}
              hideNextButton
              hidePrevButton
              color="primary"
            />
          </div>
        </div>
      )}
    </>
  );
}
